// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"dbd4aa3c","110":"b4d3fdb4","140":"94a066fc","422":"d780d36b","453":"c9161952","619":"39d7b853","624":"490e8f1d","784":"a805402d","841":"dbd3d7e3"}[chunkId] + ".chunk.js";
};